3<template>
  <treeselect
    ref="treeselect"
    v-model="internalValue"
    :disabled="deactivated"
    :multiple="multiple"
    :options="tags"
    :show-count="true"
    showCountOf="LEAF_DESCENDANTS"
    :placeholder="
      placeholder
        ? placeholder
        : multiple
        ? 'Select one or more tags'
        : 'Select a single tag'
    "
    :disable-branch-nodes="!multiple"
    :flatten-search-results="true"
    value-consists-of="LEAF_PRIORITY"
  >
    <!-- :value="treeValue"
    @input="onChange" -->
    <div slot="value-label" slot-scope="{ node }">{{ node.raw.label }}</div>
  </treeselect>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
// import styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

//import _ from "lodash";

export default {
  components: { Treeselect },
  props: {
    value: Object | Array,
    placeholder: String | undefined,
    multiple: {
      type: Boolean,
      default: false,
    },
    deactivated: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tags: [
        {
          id: "campus",
          label: "Campus",
          children: [
            {
              id: "campus:playbook",
              label: "Playbook",
            },
            {
              id: "campus:staffmeeting",
              label: "Staffmeeting",
            },
            {
              id: "campus:social",
              label: "Social",
            },
            {
              id: "campus:winwin",
              label: "Win Win",
            },
            {
              id: "campus:walkyourtalk",
              label: "Walk Your Talk",
            },
            {
              id: "campus:ambassador",
              label: "Ambassador",
            },
            {
              id: "campus:performance",
              label: "Performance",
            },
            {
              id: "campus:masterclass",
              label: "Masterclass",
            },

            {
              id: "campus:rookie",
              label: "VMT Rookie",
            },
            {
              id: "campus:skilled",
              label: "VMT Skilled",
            },
            {
              id: "campus:expert",
              label: "VMT Expert",
            },
            {
              id: "campus:paratus",
              label: "VMT Paratus",
            },

            {
              id: "campus:vmtwebinar1",
              label: "Vmt Webinar 1",
            },
            {
              id: "campus:vmtwebinar2",
              label: "Vmt Webinar 2",
            },
            {
              id: "campus:vmtwebinar3",
              label: "Vmt Webinar 3",
            },
            {
              id: "campus:vmtwebinar4",
              label: "Vmt Webinar 4",
            },
            {
              id: "campus:vmtwebinar5",
              label: "Vmt Webinar 5",
            },
            {
              id: "campus:vmtwebinar6",
              label: "Vmt Webinar 6",
            },
            {
              id: "campus:vmtwebinar7",
              label: "Vmt Webinar 7",
            },
            {
              id: "campus:vmtwebinar8",
              label: "Vmt Webinar 8",
            },
            {
              id: "campus:vmtwebinar9",
              label: "Vmt Webinar 9",
            },
            {
              id: "campus:vmtwebinar10",
              label: "Vmt Webinar 10",
            },
            {
              id: "campus:vmtwebinarexam",
              label: "Webinar Exam",
            },
            {
              id: "campus:some",
              label: "SoMe",
            },
            {
              id: "campus:firstaid",
              label: "First Aid",
            },
            {
              id: "campus:evacuation",
              label: "Evacuation",
            },
            {
              id: "campus:tvm",
              label: "TVM",
            },
            {
              id: "campus:tvmtime",
              label: "TVM Time Management",
            },
            {
              id: "campus:tvmcoach",
              label: "TVM Coaching",
            },
            {
              id: "campus:tvmmotiv",
              label: "TVM Motivation",
            },
            {
              id: "campus:tvmhpt",
              label: "TVM High Performance Team",
            },
            {
              id: "campus:tvmrecruit",
              label: "TVM Recruitment",
            },
            {
              id: "campus:tvmonboard",
              label: "TVM Onboarding",
            },
            {
              id: "campus:tvmstars",
              label: "TVM Stars",
            },
            {
              id: "campus:tvmpresentation",
              label: "TVM Presenation Technique",
            },
            {
              id: "campus:channel_basic",
              label: "Channel Basic",
            },
            {
              id: "campus:channel_advanced",
              label: "Channel Advanced",
            },
            {
              id: "campus:channel_pro",
              label: "Channel Pro",
            },

          ],
        },
        {
          id: "position",
          label: "Position",
          children: [
            {
              id: "position:bartender",
              label: "Bartender",
            },
            {
              id: "position:wardrobe",
              label: "Wardrobe",
            },
            {
              id: "position:runner",
              label: "Runner",
            },
            {
              id: "position:host",
              label: "Host",
            },
            {
              id: "position:shiftmanager",
              label: "Shift Manager",
            },
            {
              id: "position:waiter",
              label: "Waiter",
            },
          ],
        },

        {
          id: "country",
          label: "Country",
          children: [
            {
              id: "country:dk",
              label: "Denmark",
            },
            {
              id: "country:no",
              label: "Norway",
            },
            {
              id: "country:fi",
              label: "Finland",
            },
            {
              id: "country:uk",
              label: "United Kingdom",
            },
          ],
        },
        {
          id: "level",
          label: "Level",
          children: [
            {
              id: "level:sm",
              label: "Shift Manager",
            },
            {
              id: "level:avm",
              label: "Assistant Venue Manager",
            },
            {
              id: "level:vm",
              label: "Venue Manager",
            },
            {
              id: "level:svm",
              label: "Senior Venue Manager",
            },
            {
              id: "level:rm",
              label: "Regional Manager",
            },
            {
              id: "level:rd",
              label: "Regional Director",
            },
            {
              id: "level:cm",
              label: "Country Director",
            },
          ],
        },
      ],
    };
  },
  methods: {},
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(v) {
        if (v) {
          this.$emit("input", v);
          this.$emit("tag", v);
          this.$refs.treeselect.clear();
        }

        // if (!this.multiple) {
        //   this.$emit("input", v);
        // } else {
        //   const venues = v.flatMap(nodeId => {
        //     const node = this.$refs.treeselect.getNode(nodeId);
        //     return this.getVenues(node);
        //   });

        //   this.$emit("input", venues);
        // }
      },
    },
  },
  async mounted() {
    /*     this.venues = (
      await this.$http.get(process.env.VUE_APP_API + "/Venues")
    ).data; */
  },
};
</script>

<style lang="scss">
.vue-treeselect__multi-value {
  max-height: 180px;
  overflow-y: auto;
}
</style>